import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import imgKkp from '../../../assets/images/logo_kkp.jpg'
import srcArial from '../../../assets/custom/font/arial/arial.ttf'
import srcArialBold from '../../../assets/custom/font/arial/ARIBL0.ttf'
import { useEffect, useMemo, useState } from "react";
import TransaksiService from "../../../services/transaksi/TransaksiService";
import UserService from "../../../services/user/UserService";
import { formatDateStringDateFirst } from "../../../utilities/Utils";
// import UPT from "../../../utilities/UPT";
// import ttdImg from "../../../assets/images/ttd_basah.JPG"

Font.register({ family: 'Arial', src: srcArial })
Font.register({ family: 'Arial-Bold', src: srcArialBold })

// Font.register({ family: 'Roboto-Italic', src: srcRobotoItalic })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 42,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 115,
        height: 100,
    },
    headingTtd: {
        width: 189,
        height: 123,
    },
    table: {
        display: "table",
        width: "auto"
    },
    tableRow: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    tableCol: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 1
    },
    text: {
        fontSize: 10,
        fontFamily: "Arial"
    },
    textBold: {
        fontSize: 12,
        fontFamily: "Arial-Bold"
    }
})

const DraftSPTEvaluasiTeknis = ({ dataDisposisi, datappm }) => {

    let transaksiService = useMemo(() => new TransaksiService(), [])
    let userService = useMemo(() => new UserService(), [])

    const [uraianUpt, setUraianUpt] = useState(null)
    const [alamatUpt, setAlamatUpt] = useState(null)

    const [listPenugasanDetil, setListPenugasanDetil] = useState([])

    useEffect(() => {
        if (!dataDisposisi) return
        const fetchAllOptions = async () => {
            try {
                const resUpt = await userService.getUptById(datappm.kdUpt)
                setUraianUpt(resUpt.data.nmUnit)
                setAlamatUpt(resUpt.data.alamatUnit)

                const resTugasDetil = await transaksiService.listPenugasanDetil(datappm.nomorAju, dataDisposisi.noTugas)
                setListPenugasanDetil(resTugasDetil.data)
            } catch (error) {
                console.log(error)
                setListPenugasanDetil([])
            }
        }
        fetchAllOptions()
    }, [dataDisposisi, datappm, transaksiService, userService])
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={[styles.table, { marginBottom: 10 }]}>
                    <View style={[styles.tableRow, { borderBottom: 2, borderBottomStyle: 'solid' }]}>
                        <View style={[styles.tableCol, { width: '25%' }]}>
                            <Image style={styles.headingImg} src={imgKkp} />
                        </View>
                        <View style={[styles.tableCol, { width: '75%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'center', color: '#7895be' }]}>KEMENTERIAN KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.text, { fontSize: 14, textAlign: 'center', color: '#7895be' }]}>BADAN PENGENDALIAN DAN PENGAWASAN MUTU</Text>
                            <Text style={[styles.text, { fontSize: 14, textAlign: 'center', color: '#7895be' }]}>HASIL KELAUTAN DAN PERIKANAN</Text>
                            {/* <Text style={[styles.textBold, { fontSize: 14, textAlign: 'center', color: '#7895be' }]}>BALAI KARANTINA IKAN, PENGENDALIAN MUTU</Text>
                            <Text style={[styles.textBold, { fontSize: 14, textAlign: 'center', color: '#7895be' }]}>DAN KEAMANAN HASIL PERIKANAN JAKARTA II</Text> */}
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'center', color: '#7895be' }]}>{uraianUpt}</Text>
                            {/* <Text style={[styles.text, { textAlign: 'center' }]}>Jl. ENGGANO NO.16, TJ. PRIOK, KEC. TJ. PRIOK, JKT UTARA</Text> */}
                            {/* <Text style={[styles.text, { textAlign: 'center' }]}>DAERAH KHUSUS IBUKOTA JAKARTA 14310</Text> */}
                            <Text style={[styles.text, { textAlign: 'center' }]}>{alamatUpt}</Text>
                            {/* <Text style={[styles.text, { textAlign: 'center' }]}>TELEPON (021) 3519070 (LACAK), FAKSIMILE (021) 3513282</Text> */}
                            {/* <Text style={[styles.text, { textAlign: 'center' }]}>LAMAN www.kkp.go.id, EMAIL setban.bkipm@kkp.go.id</Text> */}
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 10 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'center' }]}>SURAT PERINTAH EVALUASI TEKNIS</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>No. {dataDisposisi !== undefined ? dataDisposisi.noTugas : ''}</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 10 }]}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '5%', alignItems: 'center' }]}>
                        </View>
                        <View style={[styles.tableCol, { width: '90%', alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'justify' }]}>Sesuai dengan prosedur penerbitan Sertifikat Kesehatan Ikan dan Produk Perikanan (SKIPP) Ekspor diperlukan evaluasi teknis oleh petugas UPT {uraianUpt}, maka dengan ini saya menugaskan :</Text>
                        </View>
                        {/* <View style={[styles.tableCol, { width: '10%', alignItems: 'center' }]}>
                        </View> */}
                    </View>
                </View>
                {
                    listPenugasanDetil !== undefined && listPenugasanDetil.map((detil, index) => {
                        return (
                            <View style={[styles.table, { marginBottom: 10 }]}>
                                <View style={styles.tableRow}>
                                    <View style={[styles.tableCol, { width: '10%' }]}>
                                        {/* <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Dasar</Text> */}
                                    </View>
                                    <View style={[styles.tableCol, { width: '25%' }]}>
                                        <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Nama</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: '3%' }]}>
                                        <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: '62%' }]}>
                                        <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{detil.namaPetugas}</Text>
                                    </View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={[styles.tableCol, { width: '10%' }]}>
                                        {/* <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Dasar</Text> */}
                                    </View>
                                    <View style={[styles.tableCol, { width: '25%' }]}>
                                        <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>NIP</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: '3%' }]}>
                                        <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: '62%' }]}>
                                        <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{detil.nipPetugas}</Text>
                                    </View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={[styles.tableCol, { width: '10%' }]}>
                                        {/* <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Dasar</Text> */}
                                    </View>
                                    <View style={[styles.tableCol, { width: '25%' }]}>
                                        <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>No Reg Inspektur Mutu</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: '3%' }]}>
                                        <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: '62%' }]}>
                                        <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                                    </View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={[styles.tableCol, { width: '10%' }]}>
                                        {/* <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Dasar</Text> */}
                                    </View>
                                    <View style={[styles.tableCol, { width: '25%' }]}>
                                        <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Jabatan</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: '3%' }]}>
                                        <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: '62%' }]}>
                                        <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                                    </View>
                                </View>
                            </View>
                        )
                    })

                }
                <View style={[styles.table, { marginBottom: 10 }]}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '5%', alignItems: 'center' }]}>
                        </View>
                        <View style={[styles.tableCol, { width: '90%', alignItems: 'justify' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'justify' }]}>Untuk melakukan evaluasi teknis Sertifikat Kesehatan Ikan dan Produk Perikanan (SKIPP) Ekspor pada tanggal {dataDisposisi !== undefined ? formatDateStringDateFirst(dataDisposisi.tglTugas) : ''} sesuai permohonan.</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 10 }]}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '5%', alignItems: 'center' }]}>
                        </View>
                        <View style={[styles.tableCol, { width: '90%', alignItems: 'justify' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'justify' }]}>Demikian disampaikan, agar dilkaksanakan dengan penuh tanggung jawab.</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Kepala {uraianUpt}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'center' }]}></Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '50%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '50%' }]}>
                            {/* <Image style={styles.headingTtd} src={ttdImg} /> */}
                        </View>
                    </View>
                    <View style={[styles.tableRow, { marginTop: '50px'}]}>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'center' }]}> {dataDisposisi !== undefined ? dataDisposisi.nmPejabat : ''}</Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    )
}

export default DraftSPTEvaluasiTeknis